import { useMutation } from "react-query";
import uploadOnboarding from "../services/uploadOnboarding";

function useUploadOnboarding() {
  return useMutation(["upload-onboarding"], uploadOnboarding);
}

export default useUploadOnboarding;
